import React from "react";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";
import { playStoreLink } from "../../ServiceConnection/serviceconnection";

export default function Footer() {
  return (
    <section>
      <footer className="relative z-10 bg-[#181a3d] backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="text-center text-purple-200">
            <p className="text-lg font-semibold mb-2">
              🌟 AstroWorld AstroLogical 🌟
            </p>
            <p className="text-sm opacity-80">Your Gateway to Vedic Wisdom</p>

            {/* Links Section */}
            <div className="flex justify-center flex-wrap gap-4 mt-6 text-sm font-medium">
              <Link
                to="/our-philosophy"
                className="hover:text-[var(--light-pink-color)] transition-opacity opacity-80"
              >
                Our Philosophy
              </Link>
              <span className="opacity-50">|</span>
              <Link
                to="/privacy-policy"
                className="hover:text-[var(--light-pink-color)] transition-opacity opacity-80"
              >
                Privacy Policy
              </Link>
              <span className="opacity-50">|</span>
              <Link
                to="/terms-and-conditions"
                className="hover:text-[var(--light-pink-color)] transition-opacity opacity-80"
              >
                Terms & Conditions
              </Link>
              <span className="opacity-50">|</span>
              <Link
                to="/support"
                className="hover:text-[var(--light-pink-color)] transition-opacity opacity-80"
              >
                Support
              </Link>
            </div>

            {/* QR Section */}
            <div className="mt-6">
              <div className="p-0 bg-white  w-[90px] h-[90px] mx-auto rounded-lg shadow-md flex flex-col items-center justify-center">
                <QRCode
                  value={playStoreLink}
                  size={70}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="L"
                />
              </div>
            </div>

            <p className="text-xs mt-[13px] opacity-80">
              Scan to download our app
            </p>
            <p className="text-xs mt-6 opacity-60">
              Disclaimer: Astrology is for guidance and entertainment purposes
              only.
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
}
